export default __webpack_public_path__ + "static/08.logo_orange-bg-13e7ad3bf4357a7b22a23c478da92e64.svg";